module.exports = __webpack_public_path__ + "static/media/patikohv.d8d601e6.png";